import { FlagHeaderCollectionQueryInput } from "@reflag/shared/flagAPI";
import { FlagViewDTO } from "@reflag/shared/flagViewAPI";

type FlagStatus = NonNullable<FlagHeaderCollectionQueryInput["status"]>;

export function getFlagViewDisplayName(
  view: Pick<FlagViewDTO, "name" | "type">,
): string {
  return view.type === "all" ? "Active" : view.name;
}

export function getFlagListStatus(
  viewType: FlagViewDTO["type"],
  searchQuery: string,
  searchArchivedFlagsEnabled: boolean,
): FlagStatus {
  if (
    searchArchivedFlagsEnabled &&
    searchQuery.trim() &&
    viewType !== "archived" &&
    viewType !== "stale"
  ) {
    return "all";
  }

  return viewType === "stale" || viewType === "archived" ? viewType : "active";
}
